<template>
    <div  class="mpro wow">
        <div class="bg"></div>
        <div class="title wow">
              <p>
                  {{$t('home').pro.text0}}<br>
                  {{$t('home').pro.text1}}
              </p>
            <p>    {{$t('home').pro.text2}}</p>
        </div>
        <div class="allImgs wow">
         <div class="lSwiper">
            <div class="img">
                <img :src="list[activeIndex].picurl" alt="">
            </div>
         </div>
         <div class="joke">
            <div class="one" @click="gotoInfo(list[activeIndex].linkurl)">
            <p>{{list[activeIndex].classname}}</p>
            <p class="html" v-html="list[activeIndex].info"></p>
            <div class="btn">
                {{$t('home').pro.text3}}
            </div>
        </div>
        <div class="rSwiper">
            <swiper :options="swiperOptionRight" class="gallery-right" ref="swiperRight" @slideChange="onSlideChange">
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                    <div class="img">
                        <img :src="item.picurl" alt="">
                    </div>
                    <div class="line"></div>
                </swiper-slide>
            </swiper>
            <div class="btn">
                <div class="pre">
                    <img src="@/assets/jtl.png" alt="">
                </div>
                <div class="next">
                    <img src="@/assets/jtr.png" alt="">
                </div>
            </div>
        </div>
         </div>
        </div>
    </div>
</template>

<script>
    import { getClass} from '../util/lang'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "mpro",
        data(){
          return{
              activeIndex:0,
              swiperOptionRight: {
                //   notNextTick: true,
                  slidesPerView:3,//一行显示3个
                  speed:1000,
                  init:false,
                  loop:true,
                  spaceBetween :33,
                  setWrapperSize :true,
                  autoplay: false,
                  slideToClickedSlide: true,
                  navigation: {
                        prevEl: '.rSwiper .btn .pre',
                        nextEl: '.rSwiper .btn .next',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView:1,
                            spaceBetween :33,
                        }
                    }
              },
              list:[],
          }
        },
        components:{swiper, swiperSlide},
        mounted(){
            this.$nextTick(()=>{
                // this.$refs.swiperTop.swiper.init()
                
                // const swiperTop = this.$refs.swiperTop.swiper
                // const swiperRight = this.$refs.swiperRight.swiper
                // swiperTop.controller.control = swiperRight
                // swiperRight.controller.control = swiperTop
                if(this.$i18n.locale==='en'){
                    this.getList('122')
                }else{
                    this.getList('22')
                }
            
            })
        },
        methods:{
            onSlideChange() {
                this.activeIndex = this.$refs.swiperRight.swiper.realIndex
                console.log(this.activeIndex)
            },
            gotoInfo(i){
                // const link=`http://products.dhkbearing.com/`
                window.open(i,'_self')
            },
            getList(id){
                const url = `${getClass(id)}`
                this.$axios.get(url).then(res => {
                    // res.data.data.pop()
                    this.list=res.data.data
                  // console.log(res.data.data)
                //   console.log(this.list);
                  setTimeout(() => {
                    this.$refs.swiperRight.swiper.init()
                },100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.mpro{
     width:100%;
    // background-color: #FBFAF6;
    position: relative;
    padding: 60px 0;
    padding-bottom: 30px;
    .bg {
        width: 100%;
        height: 671px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #FCFCF9;
    }
    .title{
        width:1440px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        animation:transition2 1s  forwards linear  ;
        margin-bottom: -80px;
        p:nth-child(1){
            color:#333333;
            font-size: 50px;
            font-family: "DINEngschriftStd";
            text-transform: uppercase;
            line-height: 43px;
            display: inline-block;
            width:auto;
        }
        p:nth-child(2){
            color:#333333;
            font-size: 25px;
            font-family: "SourceHanSansSC-Regular";
            position: relative;
            margin: 20px 0;
            &::after{
                content:'';
                display: inline-block;
                width:44px;
                height:5px;
                background:#FECD4A;
                position: absolute;
                right:0;
                bottom:-20px;
            }
        }
    }
    .allImgs{
        width:1440px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        animation:transition1 1s  forwards linear  ;
        .lSwiper{
            margin-right: 270px;
            .img {
                width: 500px;
                img {
                    width: 100%;
                }
            }
        }
        .joke {
            padding-top: 150px;
            .one {
                margin-bottom: 128px;
                .html {
                    height: 116px;
                    overflow: hidden;
                }
                p {
                    width: fit-content;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #666666;
                    line-height: 28px;
                    margin-bottom: 60px;
                }
                p:nth-child(1) {
                    width: fit-content;
                    font-size: 24px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #333333;
                    margin-bottom: 50px;
                }
                .btn {
                    width: 160px;
                    height: 50px;
                    background: #F6C02E;
                    box-shadow: 5px 7px 38px 0px rgba(246,192,46,0.6);
                    border-radius: 15px;
                    font-size: 16px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 50px;
                    cursor: pointer;
                }
            }
            .rSwiper{
                width: 639px;
                height:100%;
                position: relative;
                .btn {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 99;
                    width: 120%;
                    .pre {
                        cursor: pointer;
                    }
                    .next {
                        cursor: pointer;
                    }
                }
            .gallery-right{
                width:100%;
                height:100%;
                .swiper-wrapper {
                    width: 639px;
                    .swiper-slide {
                        width: 191px;
                        position: relative;
                        .img {
                            width: 189px;
                            height: 189px;
                            background: #fff;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border: 1px solid rgba($color: #000000, $alpha: 0.1);
                            border-radius: 4px;
                            img {
                                display: block;
                                width: 180px;
                            }
                        }
                        .line {
                            margin: 20px auto 0;
                            width: 175px;
                            height: 1px;
                            background: #F6C02E;
                            opacity: 0;
                            transition: 0.6s;
                        }
                    }
                    .swiper-slide-active {
                        .line {
                            opacity: 1;
                        }
                    }
                }
                
                .swiper-slide-active{
                    .one{
                        clip-path: polygon(0 0,0 100%,100% 100%,100% 0);
                        opacity: 1;
                    }
                }
            }
        }
        }
    }
    @keyframes transition1 {
        0% {
            transform: translate(-100px,-100px);
            opacity: 0;
        }
        100% {
            transform: translate(0,0);
            opacity: 1;
        }
    }
    @keyframes transition2 {
        0% {
            transform: translate(100px,-100px);
            opacity: 0;
        }
        100% {
            transform: translate(0,0);
            opacity: 1;
        }
    }
    @media screen and (max-width: 1440px){
     .title,.allImgs{
         width:90%;
     }
    }
    @media screen and (max-width: 1000px){
        .title{
            align-items: center;
            text-align: center;
            margin-bottom: 20px;
            p:nth-child(1){
                font-size: 30px;
            }
            p:nth-child(2){
                &::after{
                    right:30%;
                }
            }
        }
        .allImgs{
            margin-top: 75px;
            flex-direction: column;
            .lSwiper,.rSwiper{
                width:100%;
            }
            .lSwiper{
                .swiper-pagination{
                    bottom: 15px;
                    width:80%;
                    right:0;
                }
            }
            .rSwiper{
                .gallery-right{
                    .item{
                        padding: 0;
                        .one{
                            margin-top: 0;
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 1000px){
    .mpro{
        padding: 20px 0;
    }
}
@media screen and (max-width: 1700px){
    .mpro .allImgs .lSwiper .img {
        width: 400px;
    }
    .mpro .allImgs {
        width: 90%;
    }
    .mpro .allImgs .lSwiper {
        width: 35%;
        margin-right: 15%;
    }
    .mpro .allImgs .lSwiper .img {
        width: 100%;
    }
    .mpro .allImgs .joke .rSwiper .btn {
        width: 110%;
    }
}
@media screen and (max-width: 1024px){
    .mpro .allImgs {
        flex-direction: column;
    }
    .mpro .allImgs .lSwiper {
        width: 100%;
        margin-right: 0;
    }
    .mpro .allImgs .lSwiper .img {
        width: 80%;
        margin: auto;
    }
    .mpro .allImgs .joke {
        width: 100%;
        padding-top: 40px;
    }
    .mpro .allImgs .joke .one p:nth-child(1) {
        font-size: 20px;
        margin-bottom: 20px;
    }
    .mpro .allImgs .joke .one .html {
        margin-bottom: 40px;
    }
    .mpro .allImgs .joke .rSwiper {
        width: 100%;
    }
    .mpro .allImgs .joke .rSwiper .gallery-right .swiper-wrapper .swiper-slide .img {
        margin: auto;
    }
    .mpro .allImgs .joke .rSwiper .btn {
        width: 90%;
    }
    .mpro .allImgs .joke .one {
        margin-bottom: 40px;
    }
    .mpro .title {
        text-align: left;
        align-items: flex-start;
    }
    .mpro .title p:nth-child(1) {
        line-height: 32px;
    }
}
</style>
<style scoped>
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet {
        width:5px;
        height:5px;
        background:#333333;
        border-radius:50%;
        margin-left: 30px;
        transition: all 600ms;
        position: relative;
        opacity: 1;
    }
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet::before{
        content:'';
        width:35px;
        height:35px;
        border:1px solid #FECE4A;
        border-radius:50%;
        display: inline-block;
        position: absolute;
        left:-15px;
        top:-15px;
        opacity: 0;
        transition: all 600ms;
    }
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet-active{
        background-color:#FECE4A ;
    }
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet-active::before{
        opacity: 1;
    }
</style>
